export default {"src":"/_next/static/media/powered-by-visitdays-logo-blue.9b8b0986.svg","height":19,"width":164,"blurWidth":0,"blurHeight":0};